const EntregasComponent = () => {
    return(
        <div>EntregasComponent</div>
    )
}
export default EntregasComponent;